import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const DesktopSortContainer = styled("div")`
    padding: 0 1rem 0 0;
    grid-area: end;
    display: flex;
    justify-content: flex-end;
    min-width: 16rem;

    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`

export default DesktopSortContainer
